<div class="modal fade" id="{{id}}" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
            {{header}}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
           ></button>
        </div>
        <div class="modal-body">
          {{body}}
          <ng-content></ng-content>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" >
            {{closeButtonText}}
          </button>
          <button type="button" class="btn btn-primary" (click)="handleClick()">
            {{okButtonText}}
          </button>
        </div>
      </div>
    </div>
  </div>